module.exports = __webpack_public_path__ + "static/you-cew-2-mobile-96d753f79519637d824928daf51a82bd.jpg";